@if (!hasAcceptedAllAgreements) {
	<app-agreements-acceptance
		[inMfe]="false"
		(provideOpenFunc)="openAgreementsModal = $event"></app-agreements-acceptance>
}

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
